import React from 'react'
import Navbar from '../components/Navbar';
import Register from '../components/Register';
import Footer from '../components/Footer'


export default function RegisterPage() {
  return (
    <>
        <Navbar></Navbar>
        <Register></Register>
        <Footer></Footer>
    </>
  )
}
